'use client';

import { createContext, PropsWithChildren, useContext, useMemo } from 'react';

const GiftcardsPagesLayoutContentContext = createContext(
  {} as GiftcardsPagesLayoutContent,
);

interface Props extends PropsWithChildren {
  content: GiftcardsPagesLayoutContent;
}

export const GiftcardsPagesLayoutContentContextProvider = (props: Props) => {
  const { children, content } = props;

  const value = useMemo(() => content, [content]);

  return (
    <GiftcardsPagesLayoutContentContext.Provider value={value}>
      {children}
    </GiftcardsPagesLayoutContentContext.Provider>
  );
};

export const useGiftcardsPagesLayoutContent = () =>
  useContext(GiftcardsPagesLayoutContentContext);
